// @flow

import type { UserData } from "./user-data-type";

import { fetchUserData } from "./fetch-user-data";
import { getCacheUserData, setCacheUserData } from "./cache-user-data";

import { isUserDataValid } from "./validate-user-data";

export async function getUserData(): Promise<?UserData> {
    let userData = getCacheUserData();
    const isValid = userData && isUserDataValid(userData);
    if (!userData || !isValid) {
        userData = await fetchUserData();
        setCacheUserData(userData);
    }
    return userData;
}
